import http from "./http";

//#region Función para obtener las configuraciones
async function GetInfoConfiguracion() {
  const result = await http.get("https://democatalogo.somee.com/configuracion");
  return  result.data
}
//#endregion

//#region Función para actualizar la configuracion en la base de datos
async function UpdateConfiguracion(data, headers) {
  return http.put("https://democatalogo.somee.com/configuracion", data, { headers });
}
//#endregion

//#region Export
export { GetInfoConfiguracion, UpdateConfiguracion };
//#endregion
